import { render, staticRenderFns } from "./ResearchDevelopmentBulletinBoard-3.8.vue?vue&type=template&id=ca71a7ae&scoped=true&"
import script from "./ResearchDevelopmentBulletinBoard-3.8.vue?vue&type=script&lang=js&"
export * from "./ResearchDevelopmentBulletinBoard-3.8.vue?vue&type=script&lang=js&"
import style0 from "./ResearchDevelopmentBulletinBoard-3.8.vue?vue&type=style&index=0&id=ca71a7ae&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca71a7ae",
  null
  
)

export default component.exports